import service from "@/store/services/revisiones-service";

const state = {
  list: {},
  revision: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, revision) => {
    state.revision = revision;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((revision) => {
      commit("SET_RESOURCE", revision);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((revision) => {
      commit("SET_RESOURCE", revision);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((revision) => {
      commit("SET_RESOURCE", revision);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  revision: (state) => state.revision,
  dropdown: (state) => {
    state.list.map((revision) => console.log(revision));
    return state.list.map((revision) => ({
      id: revision.id,
      alias: revision.alias,
    }));
  },
};

const revisiones = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default revisiones;
